import { digestCalendarDate, type DigestKind } from '@chatsdet/types';

export const DIGEST_KIND_LABEL: Record<DigestKind, string> = { daily: 'Daily', weekly: 'Weekly' };

/**
 * Web-facing digest title: the web UI leads with the window date rather than
 * the word "digest" (Settings → Digests and the API/email surfaces keep the
 * feature name). Daily reads as a full weekday date ("Thursday, September 4");
 * weekly reads as a short range ("Aug 28 – Sep 4"). Dates are formatted in the
 * digest's own timezone — the zone the window and its by-day buckets were
 * computed in — so the title agrees with the facts beneath it.
 */
export function digestWindowLabel(
  kind: DigestKind,
  windowStart: string,
  windowEnd: string,
  timeZone: string
): string {
  if (kind === 'daily') {
    return new Date(windowEnd).toLocaleDateString(undefined, {
      timeZone,
      weekday: 'long',
      month: 'long',
      day: 'numeric',
    });
  }
  const short = { timeZone, month: 'short', day: 'numeric' } as const;
  return `${new Date(windowStart).toLocaleDateString(undefined, short)} – ${new Date(windowEnd).toLocaleDateString(undefined, short)}`;
}

/** The exact window as calendar days in the digest's zone: "2026-09-03 – 2026-09-04 (America/Chicago)". */
export function digestWindowRange(windowStart: string, windowEnd: string, timeZone: string): string {
  return `${digestCalendarDate(windowStart, timeZone)} – ${digestCalendarDate(windowEnd, timeZone)} (${timeZone})`;
}
